// extracted by mini-css-extract-plugin
export default {"row":"ScrollRow-module__row--QSvAl"};